module.exports = __webpack_public_path__ + "static/img/2-80w.8a3e0eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/two/2-80w.png
// module id = jPBZ
// module chunks = 1